var map = {
  "./de.json": "8952",
  "./el.json": "3366",
  "./en-US.json": "9771",
  "./es-419.json": "6424",
  "./es.json": "4163",
  "./fi.json": "5910",
  "./fr-CA.json": "7206",
  "./fr.json": "6767",
  "./it.json": "9914",
  "./ja.json": "1314",
  "./ko.json": "9889",
  "./nl.json": "4365",
  "./pl.json": "6727",
  "./pt-BR.json": "6550",
  "./pt.json": "4415",
  "./ro.json": "5804",
  "./sv.json": "7142",
  "./zh-CN.json": "3053"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 6408;
